import Vue from "vue";
import Vuex from "vuex";

// import auth from "./auth.module";
import theAuth from "./theAuth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    theAuth,
    // auth,
    htmlClass,
    config,
    breadcrumbs,
    profile
  }
});
